// extracted by mini-css-extract-plugin
export default {"container":"size-display_container__1-k+R","box":"size-display_box__4RNtG","active":"size-display_active__mHtJs"};